import { Asset } from 'app-lib/assetUtils'
import { Button } from 'bzx-common/src/ui-framework'
import { observer } from 'mobx-react'
import React, { CSSProperties } from 'react'
import AssetDropdown from 'shared-components/AssetDropdown'
import ChartLoader from 'shared-components/ChartLoader'
import StatsVM from '../../StatsVM'

const StatsChart = ({ vm }: { vm: StatsVM }) => {
  const { empty, error } = vm.chartStatus

  const styles: Record<string, CSSProperties> = {
    selectedLine: { color: vm.selectedLine },
    secondLine: { color: vm.secondLine },
  }

  return (
    <>
      <div className="stats-chart__dropdown flex-wrap">
        {vm.assets && (
          <AssetDropdown
            selectedAsset={vm.selectedAsset || Asset.UNKNOWN}
            onAssetChange={vm.onAssetSwitch}
            assets={vm.firstAssets}
            emptyLabel="All"
            emptyIcon={vm.iconName}
          />
        )}
        {vm.selectedAsset && vm.assets && (
          <AssetDropdown
            selectedAsset={vm.secondAsset || Asset.UNKNOWN}
            onAssetChange={vm.onSecondAssetSwitch}
            assets={vm.secondAssets}
            className="stats-chart__compare"
            emptyLabel="Compare"
          />
        )}
        {vm.selectedAsset && (
          <div className="btn--sticked-horizontal margin-bottom-2">
            <Button
              variant="tab-blue"
              onClick={vm.onDataSwitch}
              onClickEmit="value"
              size="narrow-fixed"
              value="tvlUsd"
              active={vm.selectedData === 'tvlUsd'}>
              tvl usd
            </Button>
            <Button
              variant="tab-blue"
              onClick={vm.onDataSwitch}
              onClickEmit="value"
              size="narrow-fixed"
              value="tvl"
              active={vm.selectedData === 'tvl'}>
              tvl
            </Button>
            <Button
              variant="tab-blue"
              onClick={vm.onDataSwitch}
              onClickEmit="value"
              size="narrow-fixed"
              value="apr"
              active={vm.selectedData === 'apr'}>
              apr
            </Button>
          </div>
        )}
      </div>
      <div className="stats-chart__label">
        <div>
          <span>
            {' '}
            <b>{vm.dataLabel} </b>
          </span>
          {vm.secondAsset && (
            <span className="padded-left-05">
              <b>
                <span style={styles.selectedLine}>{vm.selectedAsset}</span>
                {' - '}
                <span style={styles.secondLine}>{vm.secondAsset}</span>
              </b>
            </span>
          )}
        </div>
      </div>
      <div ref={vm.chartContainer} className="stats-chart__container pos-rel" />
      {(empty || error) && <ChartLoader type="area"> {error}</ChartLoader>}
      {}
    </>
  )
}

export default observer(StatsChart)
